"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BodyStyled = _styledComponents.default.div.withConfig({
  displayName: "Body__BodyStyled",
  componentId: "sc-1jhu866-0"
})(["align-items:center;display:flex;flex:1 1 auto;flex-direction:column;justify-content:flex-start;padding-top:", ";position:relative;", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.immersiveFlow.immersiveFlowMobileMinDistanceFromTop;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      media = _ref2$theme.media,
      immersiveFlow = _ref2$theme.immersiveFlow;
  return media.medium((0, _styledComponents.css)(["padding-top:", ";"], immersiveFlow.immersiveFlowMinDistanceFromTop));
});

var BodyInner = _styledComponents.default.div.withConfig({
  displayName: "Body__BodyInner",
  componentId: "sc-1jhu866-1"
})(["margin:auto;max-width:", ";", ";", ";"], (0, _polished.rem)('288px'), function (_ref3) {
  var media = _ref3.theme.media;
  return media.medium((0, _styledComponents.css)(["max-width:", ";"], (0, _polished.rem)('540px')));
}, function (_ref4) {
  var media = _ref4.theme.media;
  return media.large((0, _styledComponents.css)(["max-width:", ";"], (0, _polished.rem)('728px')));
});

var BodyInnerContent = _styledComponents.default.div.withConfig({
  displayName: "Body__BodyInnerContent",
  componentId: "sc-1jhu866-2"
})(["padding-bottom:", ";", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.immersiveFlow.immersiveFlowMobileMinDistanceFromBottom;
}, function (_ref6) {
  var _ref6$theme = _ref6.theme,
      media = _ref6$theme.media,
      immersiveFlow = _ref6$theme.immersiveFlow;
  return media.medium((0, _styledComponents.css)(["padding-bottom:", ";"], immersiveFlow.immersiveFlowMinDistanceFromBottom));
});

var Body = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Body, _React$Component);

  var _super = _createSuper(Body);

  function Body() {
    (0, _classCallCheck2.default)(this, Body);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Body, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return /*#__PURE__*/_react.default.createElement(BodyStyled, {
        className: className,
        role: "main"
      }, /*#__PURE__*/_react.default.createElement(BodyInner, null, /*#__PURE__*/_react.default.createElement(BodyInnerContent, null, children)));
    }
  }]);
  return Body;
}(_react.default.Component);

Body.propTypes = {
  /** Custom class name to add to Body. */
  className: _propTypes.default.string,

  /** Children nodes of body */
  children: _propTypes.default.node
};
var _default = Body;
exports.default = _default;
//# sourceMappingURL=Body.js.map